import { postJSON } from "../../shared_component/utils/fetch"

const OTP_BASE_URL = `${process.env.REACT_APP_API_URL}/api/v6`
const REQUEST_OTP = `${OTP_BASE_URL}/generate_otp`
const RETAIL_DEFAULT = "retail_default"

export const VERIFY_OTP = `${OTP_BASE_URL}/sessions`

export const EMAIL = "email"
export const PHONE = "phone"
export const OTP = "otp"

export function requestOtp(payload) {
  return async function (dispatch) {
    let url = REQUEST_OTP

    const apiPayload = {
      query: RETAIL_DEFAULT,
      [payload.type === EMAIL ? EMAIL : PHONE]: payload.value
    }

    const response = await postJSON(url, apiPayload, {})

    if (response.result) {
      return response
    } else {
      payload.callback && payload.callback("failure", { message: response.error })
    }

    return response
  }
}
